export function isEmailValid(email: string): boolean {
  const regex =
    /^(?!.*\.\.)(?:[A-Za-z0-9._%+-]+)@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,})$/;
  return regex.test(String(email).toLowerCase());
}
